import classNames from 'classnames'
import React from 'react'
import {Animated} from '../../../../../../commons/components/animated'
import {FullDateLocation} from '../../full-date-location'
import {Ribbon} from '../../ribbon'
import {RsvpButton} from '../../rsvp-button'
import {Date} from './date'
import {Description} from './description'
import {Image} from './image'
import {Members} from './members'
import s from './mobile-item.scss'
import {Share} from './share'
import {Title} from './title'
import {ItemProps} from '.'

export const MobileItem = ({
  t,
  event,
  opened,
  hovered,
  showDate,
  showImage,
  showMembers,
  listLayout,
  squareImage,
  listShowFullDate,
  listShowLocation,
  listShowDescription,
  additionalComponentsHidden,
  mobile,
  showRibbon,
  dateSize,
  isSite,
  scheduleTbd,
}: ItemProps) => (
  <>
    {(showImage || showDate) && (
      <div className={classNames(s.imageDate, {[s.imageOverlay]: showImage})}>
        <Image event={event} squareImage={squareImage} />
        <div className={showImage ? s.dateOnImage : s.date}>
          <Date
            event={event}
            scheduleTbd={scheduleTbd}
            size={dateSize}
            t={t}
            customColorClass={showImage ? s.dateWithImage : s.dateWithoutImage}
          />
        </div>
      </div>
    )}
    <div className={classNames({[s.contentContainer]: showImage})}>
      {showRibbon ? <Ribbon event={event} className={s.ribbon} /> : null}
      <Title
        active={!additionalComponentsHidden && (hovered || opened)}
        event={event}
        opened={opened}
        listLayout={listLayout}
        showArrow={!additionalComponentsHidden}
        mobile={mobile}
      />
      <Animated disabled={!isSite} show={opened && !additionalComponentsHidden} height={calculateContentHeight}>
        <div className={classNames(s.content, listLayout ? s.listContentText : s.mobileCardsContentText)}>
          <FullDateLocation event={event} showDate={listShowFullDate} showLocation={listShowLocation} />
          <Members event={event} visible={showMembers} mobile={mobile} />
          <Description event={event} visible={listShowDescription} />
          <Share t={t} event={event} />
        </div>
      </Animated>
      <div style={{marginTop: opened ? 24 : 30, width: mobile ? '100%' : null}}>
        <RsvpButton event={event} fullWidth={mobile} />
      </div>
    </div>
  </>
)

const calculateContentHeight = (element: HTMLElement) => element.offsetHeight + 60
